(function ($) {
  /* aos */
  let scrollRef = 0;
  window.addEventListener("scroll", function () {
    scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  });
  /* banner scroll button */
  $('.hero-banner-sec .scroll-btn').click(function () {
    $('html, body').animate({
      scrollTop: $(".upgrade-net-sec").offset().top - 75
    }, 500);
  })

  /* active menu class */

  var setActive = function () {
    let url = window.location.pathname.split('/').pop();
    $(".site-header .site-navigation ul li a").each(function () {
      if ($(this).attr('href').split('/').pop() == url || $(this).attr('href').split('/').pop() == '') {
        $(this).addClass("active");
      }
    })

  };

  $(function () {
    setActive();
  });


  /* menu toggle button */
  $('.site-header .menu-toggle-btn').click(function () {
    $(this).toggleClass('toggled')
    $('.site-header').toggleClass('menuActive');
  })

  /* upgrade service slider */
  var upgradeSwiper = new Swiper(".upgrade-net-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".custom-nav-next",
      prevEl: ".custom-nav-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    breakpoints: {
      500: {
        slidesPerView: 1.5,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 2.8,
        spaceBetween: 30,
      },
    },
  });

  /* easy setup slider */
  var setupSwiper = new Swiper(".setup-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".custom-nav-next",
      prevEl: ".custom-nav-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.2,
        spaceBetween: 70,
      },
      992: {
        slidesPerView: 1.4,
        spaceBetween: 100,
      },
      1300: {
        slidesPerView: 1.4,
        spaceBetween: 180,
      },
    },
  });

  /* review slider */
  var reviewSwiper = new Swiper(".review-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".review-nav .pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".review-nav .nav-next",
      prevEl: ".review-nav .nav-prev",
    },
  });

  /* amazon review slider */
  var amazonReviewSwiper = new Swiper(".amazon-review-slider", {
    slidesPerView: 2,
    spaceBetween: 55,
    //     pagination: {
    //       el: ".review-nav .pagination",
    //     },
    //     navigation: {
    //       nextEl: ".review-nav .nav-next",
    //       prevEl: ".review-nav .nav-prev",
    //     },
  });

  /* team swiper */
  var teamSwiper = new Swiper(".team-swiper", {
    slidesPerView: 2,
    slidesPerGroup: 2,
    loop: true,
    grid: {
      rows: 2,
    },
    spaceBetween: 15,
    navigation: {
      nextEl: ".team-nav.next",
      prevEl: ".team-nav.prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      992: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
      1201: {
        slidesPerView: 6,
        slidesPerGroup: 6,
      },
    },
  });
  var slideHeight = $('.team-slider-box .swiper-slide').width() * 2;
  $('.team-slider-box').css('height', slideHeight + 'px');

  /* mission slider */
  var missionSwiper = new Swiper(".mission-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".mission-slider-nav .nav-btn.next",
      prevEl: ".mission-slider-nav .nav-btn.prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
  });

  /* features slider */
  var featuresNavSwiper = new Swiper(".features-nav-swiper", {
    direction: "horizontal",
    slidesPerView: "auto",
    spaceBetween: 0,
    watchSlidesProgress: true,
    breakpoints: {
      767: {
        direction: "horizontal",
        slidesPerView: 'auto',
      },
    },
    breakpoints: {
      992: {
        direction: "vertical",
        slidesPerView: 'auto',
      },
    },

  });
  featuresNavSwiper.on('slideChange', function () {
    var activeIndex = featuresNavSwiper.activeIndex
    featuresNavSwiper.slideTo(activeIndex)
  });

  var featuresSwiper = new Swiper(".features-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    thumbs: {
      swiper: featuresNavSwiper,
    },
    navigation: {
      nextEl: ".features-slider-nav .nav-btn.next",
      prevEl: ".features-slider-nav .nav-btn.prev",
    },
  });

  /* featured blog slider */
  var featuredBlogSwiper = new Swiper(".featured-blog-swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".featured-blog-nav .pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".featured-blog-nav .nav-btn.next",
      prevEl: ".featured-blog-nav .nav-btn.prev",
    },
  });

  /* product selection checkbox */
  $('.product-help-sec .custom-checkbox input:checkbox').on('click', function () {
    var activeCase = $(this).parents('li').attr('data-attr');
    $('.product-help-sec .custom-checkbox input:checkbox').prop("checked", false);
    $(this).prop("checked", true);

    $('.product-help-sec .product-box').removeClass('active');
    $(`.product-help-sec .product-box#${activeCase}`).addClass('active');
  })

  /* stats counter bar width */
  $('.stat-box .counter').each(function () {
    var barWidth = $(this).find('.count').text();
    $(this).find('.filled-bar').css('width', barWidth + '%');
  })

  /* FAQ accordion */
  $('.accordion-panel .heading-panel').click(function () {
    $(this).find('.zmdi').toggleClass('zmdi-chevron-down zmdi-chevron-up')
    $(this).siblings('.text-panel').slideToggle();
  })

  /* Accordion content section */
  $('.accor-content-box .panel-box-main .panel-head').click(function () {
    $(this).find('.zmdi').toggleClass('zmdi-chevron-down zmdi-close')
    $(this).siblings('.panel-desc').slideToggle();
    $(this).siblings('.panel-desc').toggleClass('active');
  })


  /* window load and scroll */
  $(window).on("load scroll", function () {

    var srollTop = $(window).scrollTop();
    if (srollTop > 20) {
      $('header.site-header').addClass('fixed')
    } else {
      $('header.site-header').removeClass('fixed')
    }

  })

  /* window load and resize */
  $(window).on("load resize", function () {

    /* container offset */
    var containerWidth = $('.container').width();
    var containerFullWidth = $('body').width();
    var specialConSpace = (containerFullWidth - containerWidth) / 2;

    $('.touch-vp-left').css('margin-left', '-' + specialConSpace + 'px');
    $('.touch-vp-right').css('margin-right', '-' + specialConSpace + 'px');
    $('.upgrade-net-sec .container_slider .upgrade-net-slider').css('padding-left', specialConSpace + 'px' );

    /* features slider left offset */
    if ($('.fetaures-slider-sec').length > 0) {
      var offset = $('.fetaures-slider-sec .features-nav-swiper').offset();
      var offsetX = offset.left;
      $('.fetaures-slider-sec .circle-box').css('right', `calc(100% - ${offsetX}px)`)
    }

    var promoHeight = $('.promotion-bar').innerHeight();
    if($('.promotion-bar').hasClass('active')) {
      // $('body').css('padding-top', promoHeight + 'px')
      $('.site-header .flex').css('margin-top', promoHeight + 'px')
    }else {
      $('body').css('padding-top', '0px')
      $('.site-header .flex').css('margin-top', '0px')
    }

  });

  $(window).on("load", function () {
    $('.promotion-bar').show();

    if($('.promotion-bar').hasClass('active')) {
      $('body').addClass('promo-active');
    }else {
      $('body').removeClass('promo-active');
    }

    $(".close-promotion-bar").on('click', function () {
      $(".promotion-bar").removeClass('active');
      $(".promotion-bar").hide();
      $('body').removeClass('promo-active');
      $('body').css('padding-top', '0px')
      $('.site-header .flex').css('margin-top', '0px')
    })
  })

  /* faq section */
  jQuery(".faq-qus").click(function () {
    jQuery(this).toggleClass("active");
    jQuery(this).parent(".faq-box").siblings().children(".faq-qus").removeClass("active");
    jQuery(this).siblings().slideToggle().parent(".faq-box").siblings().children(".faq-ans").slideUp();
  });

})(jQuery);

AOS.init({
  duration: 1000,
  offset: 120,
  once: true,
});

// DO NOT TOUCH ANYTHING INSIDE BELOW
document.addEventListener('shopify:section:load', function (event) {
  (function ($) {
    /* aos */
    let scrollRef = 0;
    window.addEventListener("scroll", function () {
      scrollRef <= 10 ? scrollRef++ : AOS.refresh();
    });
    /* banner scroll button */
    $('.hero-banner-sec .scroll-btn').click(function () {
      $('html, body').animate({
        scrollTop: $(".upgrade-net-sec").offset().top - 75
      }, 500);
    })

    /* menu toggle button */
    $('.site-header .menu-toggle-btn').click(function () {
      $(this).toggleClass('toggled')
      $('.site-header').toggleClass('menuActive');
    })

    /* upgrade service slider */
    var upgradeSwiper = new Swiper(".upgrade-net-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".custom-nav-next",
        prevEl: ".custom-nav-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      breakpoints: {
        500: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 2.8,
          spaceBetween: 30,
        },
      },
    });

    /* easy setup slider */
    var setupSwiper = new Swiper(".setup-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".custom-nav-next",
        prevEl: ".custom-nav-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: 70,
        },
        992: {
          slidesPerView: 1.4,
          spaceBetween: 100,
        },
        1300: {
          slidesPerView: 1.4,
          spaceBetween: 180,
        },
      },
    });

    /* review slider */
    var reviewSwiper = new Swiper(".review-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".review-nav .pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".review-nav .nav-next",
        prevEl: ".review-nav .nav-prev",
      },
    });

    /* amazon review slider */
    var amazonReviewSwiper = new Swiper(".amazon-review-slider", {
      slidesPerView: 2,
      spaceBetween: 55,
      //     pagination: {
      //       el: ".review-nav .pagination",
      //     },
      //     navigation: {
      //       nextEl: ".review-nav .nav-next",
      //       prevEl: ".review-nav .nav-prev",
      //     },
    });

    /* team swiper */
    var teamSwiper = new Swiper(".team-swiper", {
      slidesPerView: 2,
      slidesPerGroup: 2,
      loop: true,
      grid: {
        rows: 2,
      },
      spaceBetween: 15,
      navigation: {
        nextEl: ".team-nav.next",
        prevEl: ".team-nav.prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        992: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        1201: {
          slidesPerView: 6,
          slidesPerGroup: 6,
        },
      },
    });
    var slideHeight = $('.team-slider-box .swiper-slide').width() * 2;
    $('.team-slider-box').css('height', slideHeight + 'px');

    /* mission slider */
    var missionSwiper = new Swiper(".mission-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: ".mission-slider-nav .nav-btn.next",
        prevEl: ".mission-slider-nav .nav-btn.prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });

    /* features slider */
    var featuresNavSwiper = new Swiper(".features-nav-swiper", {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 0,
      watchSlidesProgress: true,
      breakpoints: {
        767: {
          direction: "horizontal",
          slidesPerView: 'auto',
        },
      },
      breakpoints: {
        992: {
          direction: "vertical",
          slidesPerView: 'auto',
        },
      },

    });
    featuresNavSwiper.on('slideChange', function () {
      var activeIndex = featuresNavSwiper.activeIndex
      featuresNavSwiper.slideTo(activeIndex)
    });

    var featuresSwiper = new Swiper(".features-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      thumbs: {
        swiper: featuresNavSwiper,
      },
      navigation: {
        nextEl: ".features-slider-nav .nav-btn.next",
        prevEl: ".features-slider-nav .nav-btn.prev",
      },
    });

    /* featured blog slider */
    var featuredBlogSwiper = new Swiper(".featured-blog-swiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".featured-blog-nav .pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".featured-blog-nav .nav-btn.next",
        prevEl: ".featured-blog-nav .nav-btn.prev",
      },
    });

    /* product selection checkbox */
    $('.product-help-sec .custom-checkbox input:checkbox').on('click', function () {
      var activeCase = $(this).parents('li').attr('data-attr');
      $('.product-help-sec .custom-checkbox input:checkbox').prop("checked", false);
      $(this).prop("checked", true);

      $('.product-help-sec .product-box').removeClass('active');
      $(`.product-help-sec .product-box#${activeCase}`).addClass('active');
    })

    /* stats counter bar width */
    $('.stat-box .counter').each(function () {
      var barWidth = $(this).find('.count').text();
      $(this).find('.filled-bar').css('width', barWidth + '%');
    })

    /* FAQ accordion */
    $('.accordion-panel .heading-panel').click(function () {
      $(this).find('.zmdi').toggleClass('zmdi-chevron-down zmdi-chevron-up')
      $(this).siblings('.text-panel').slideToggle();
    })

    /* Accordion content section */
    $('.accor-content-box .panel-box-main .panel-head').click(function () {
      $(this).find('.zmdi').toggleClass('zmdi-chevron-down zmdi-close')
      $(this).siblings('.panel-desc').slideToggle();
      $(this).siblings('.panel-desc').toggleClass('active');
    })


    /* window load and scroll */
    $(window).on("load scroll", function () {

      var srollTop = $(window).scrollTop();
      if (srollTop > 20) {
        $('header.site-header').addClass('fixed')
      } else {
        $('header.site-header').removeClass('fixed')
      }

    })


    /* window load and resize */
    $(window).on("load resize", function () {

      /* container offset */
      var containerWidth = $('.container').width();
      var containerFullWidth = $('body').width();
      var specialConSpace = (containerFullWidth - containerWidth) / 2;

      $('.touch-vp-left').css('margin-left', '-' + specialConSpace + 'px');
      $('.touch-vp-right').css('margin-right', '-' + specialConSpace + 'px');

      /* features slider left offset */
      if ($('.fetaures-slider-sec').length > 0) {
        var offset = $('.fetaures-slider-sec .features-nav-swiper').offset();
        var offsetX = offset.left;
        $('.fetaures-slider-sec .circle-box').css('right', `calc(100% - ${offsetX}px)`)
      }


    });
    /* faq section */
    jQuery(".faq-qus").click(function () {
      jQuery(this).toggleClass("active");
      jQuery(this).parent(".faq-box").siblings().children(".faq-qus").removeClass("active");
      jQuery(this).siblings().slideToggle().parent(".faq-box").siblings().children(".faq-ans").slideUp();
    });
    jQuery(".close-promotion-bar").on('click', function () {
      jQuery(".promotion-bar").hide();
    })
  })(jQuery);
  AOS.init({
    duration: 1000,
    offset: 120,
    once: true,
  });
});
  jQuery(window).on('load', function(){
    setTimeout(()=>{
    jQuery(".site-header .site-navigation .open-submenu").on("click", function () {
      var w = jQuery(this).parents(".has_drp_menu").children("a").width();
      jQuery(this).parents(".has_drp_menu").children("span").css({
        "left": w + 10,
        "right": "unset"
      });
      jQuery(this).parents(".has_drp_menu").toggleClass("active");
      jQuery(this).siblings(".dropdown_child").slideToggle();
      if (jQuery(this).parents(".has_drp_menu").siblings().hasClass("active")) {
        jQuery(this).parents(".has_drp_menu").siblings().children(".dropdown_child").slideUp();
        jQuery(this).parents(".has_drp_menu").siblings().removeClass("active");
      }
    });
  },500);
  })
window.addEventListener('DOMContentLoaded', (event) => {
    var sp = document.createElement("span");
    sp.className = "open-submenu";
    jQuery(".site-header .site-navigation ul li.has_drp_menu").append(sp);
});



